import { mobileSizes } from "../../mockData";
import { options } from "./mockData"

export const getOptions = (index: number, width: number, isMobile: boolean, isDesktop: boolean) => { 
  const length = options.length;
  const enterIndex = index + 1;
  const spacing = isMobile ? 1 : 6;
  const mobileSize = (isMobile ? mobileSizes.xs : isDesktop ? mobileSizes.lg : mobileSizes.xl);
  return {
    from: {
      x: 0,
    },
    to: [
      {
        x: (enterIndex * spacing) + -(mobileSize.width - mobileSize.padding * 2),
        delay: (enterIndex * 20) + 6380,
        config: {
          duration: 300
        }
      },
      {
        x: ((length - index) * -spacing) + (-length * width),
        delay: 2800,
        config: {
          duration: 300
        }
      }
    ],
    loop: {
      from: {
        x: 0
      },
      delay: 3300
    }
  };
};